import React, { Component, PropTypes } from "react";
import { inject, observer } from 'mobx-react';
import { Link } from 'react-router';
import { action, observable, toJS } from "mobx";
import Form, { FormBody, TextInput, FormActions, SwitchInput, RangeInput, SelectInput } from "../../Form";
import { analysis } from '../../../actions/api';
import _ from 'lodash';
import Spinner from '../../Spinner';
import RTable from './RTable2'
import RTGraph from "./RTGraph2";
import { getByDate, deriveRatingEquation, stageAddition, getRatingCurve } from "./helpers";
import { PARAMETER_ID } from "./config";
import { getDisplayDate } from "../../../libs/date";
import REAuditHistory from "./REAuditHistory";

@inject('stationStore', 'ratingEquationStore', 'rolePermissionStore')
@observer
export default class RatingCurveEquationModify extends Component {
  static contextTypes = {
    notify: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
  };

  @observable item = {
    id: '', type: 1,
    a: '', b: '', c: '', offset: ''
  }
  @observable optimum = {
    a: '', b: '', offset: ''
  }
  @observable stageRange = {
    from: 0,
    to: 50
  };

  @observable editMode = false;
  @observable auditView = false;
  @observable dataParameters = [];
  @observable dataByDate = {};
  @observable loading = false;
  @observable graphSettings = {
    useLog: false,
    useTimeSeries: false,
    toggleAxis: false,
  };
  @observable selectedPoint = { x: null, y: null };
  @observable offsetChecked = false;

  @action onChangeStageRange = e => {
    this.stageRange = e.target.value;
    const { ratingEquationStore, params } = this.props;
    const curve = ratingEquationStore.findById(params.id)
    this.dataByDate = getByDate(this.dataParameters, this.stageRange, curve.stage || PARAMETER_ID.waterLevel, curve.discharge || PARAMETER_ID.manualDischarge);
  }
  @action onChangeField = (e, name) => this.item[name] = +e.target.value;

  componentDidMount() {
    const { params } = this.props;
    this.editMode = params.eq_id !== 'add';
    if (!!this.editMode) {
      this.reset();
    }
    this.showObservations();
  }

  @action reset = () => {
    const { params: { id, eq_id }, ratingEquationStore } = this.props;
    const foundCurve = ratingEquationStore.findById(id);
    if (foundCurve) {
      let foundEquation = foundCurve.equations.find(item => +item.id === +eq_id);
      if (foundEquation) {
        this.item.id = foundEquation.id;
        this.item.a = foundEquation.a;
        this.item.b = foundEquation.b;
        this.item.c = foundEquation.c;
        this.item.offset = foundEquation.offset;
        this.item.type = foundEquation.type;
        this.stageRange.from = foundEquation.stage_from;
        this.stageRange.to = foundEquation.stage_to;
      }
    }
  }

  showObservations = (e) => {
    const { notify } = this.context;
    !!e && e.preventDefault();
    const er = message => notify.error({ message });

    const { ratingEquationStore, params } = this.props;
    const curve = ratingEquationStore.findById(params.id)
    if (!curve) return;

    this.dataParameters = [];
    this.dataByDate = {};
    this.loading = true;
    analysis.fetchMore({
      stations: curve.station_id,
      parameters: `${curve.stage || PARAMETER_ID.waterLevel},${curve.discharge || PARAMETER_ID.manualDischarge}`,
      date_from: curve.start_time,
      date_to: curve.end_time
    }).then((data) => {
      if (!!data && !!data.length && !!data[0].parameters) {
        this.dataParameters = data[0].parameters;
        this.dataByDate = getByDate(data[0].parameters, this.stageRange, curve.stage || PARAMETER_ID.waterLevel, curve.discharge || PARAMETER_ID.manualDischarge);
        this.optimizeOffset({ updateParameters: !this.editMode });
        if (this.editMode) this.reset();
        this.loading = false;
      } else {
        this.loading = false
        return er('No data in the stations with the given field of dates');
      }
    })
  }

  optimizeOffset = ({ updateParameters } = {}) => {
    let dataByDate = this.dataByDate;
    let checkedDateKeys = Object.keys(dataByDate).filter(key => !!dataByDate[key].checked)
    if (!checkedDateKeys.length) return;
    let optimumOffset = null;

    if (+this.item.type === 2) {
      const observedDischarge = checkedDateKeys.map(date => ([dataByDate[date].WL_M, dataByDate[date].Q_M]));
      let ratingEquation = deriveRatingEquation(Object.assign([], observedDischarge), this.item.type);
      optimumOffset = {
        a: ratingEquation.parameters.a,
        b: ratingEquation.parameters.b,
        c: ratingEquation.parameters.c,
        offset: null,
      }
      if (updateParameters) {
        this.item.a = optimumOffset.a;
        this.item.b = optimumOffset.b;
        this.item.c = optimumOffset.c;
        this.item.offset = optimumOffset.offset;
      }
    } else {
      let wls = Object.keys(dataByDate).map(date => dataByDate[date].WL_M);
      let minWL = Math.floor(_.min(wls));
      let maxWL = _.max(wls);
      let h0 = this.offsetChecked ? this.item.offset : (minWL > 100 ? minWL - 100 : 0);

      while (h0 < maxWL) {
        // eslint-disable-next-line
        const observedDischarge = checkedDateKeys.map(date => {
          let stage = stageAddition(dataByDate[date].WL_M, h0 * -1); // ((100 * dataByDate[date].WL_M) - (100 * h0)) / 100;
          return ([stage, dataByDate[date].Q_M]);
          // observedDischarge.push([dataByDate[date].WL_M, dataByDate[date].Q_M])
        })
        let ratingEquation = deriveRatingEquation(Object.assign([], observedDischarge), this.item.type);
        if ((!ratingEquation.parameters.a && +ratingEquation.parameters.a !== 0) || (!ratingEquation.parameters.b && +ratingEquation.parameters.b !== 0)) {
          break;
        } else {
          if (!optimumOffset || !optimumOffset.a || optimumOffset.rmse > ratingEquation.parameters.rmse) {
            optimumOffset = {
              offset: h0,
              c: null,
              b: ratingEquation.parameters.b,
              a: ratingEquation.parameters.a,
              rmse: ratingEquation.parameters.rmse,
            }
          }
          if (this.offsetChecked) break;
          h0 = stageAddition(h0, 0.01, 2);
        }
      }
      if (!!optimumOffset) {
        this.optimum.a = optimumOffset.a;
        this.optimum.b = optimumOffset.b;
        this.optimum.c = optimumOffset.c;
        this.optimum.offset = optimumOffset.offset;

        if (updateParameters) {
          this.item.a = optimumOffset.a;
          this.item.b = optimumOffset.b;
          this.item.c = optimumOffset.c;
          this.item.offset = optimumOffset.offset;
        }
      }
    }
  }

  getRatingCurveData = (dataByDate) => {
    if (!Object.keys(this.dataByDate).length) return null;

    let checkedDateKeys = Object.keys(toJS(dataByDate)).filter(key => !!dataByDate[key].checked);
    if (!checkedDateKeys.length) return null;

    const { a, b, c, offset, type } = this.item;
    let h0 = (() => {
      switch (+type) {
        case 1: return offset;            // Power Series
        case 2: return 0;   // Polynomial Series
        default: return 0;
      }
    })();;
    let observedDischarge = [];
    let timeSeries = {
      wl: [],
      stage: {
        normal: [],
        log: []
      },
      q: {
        normal: [],
        log: []
      },
      gen_q: {
        normal: [],
        log: []
      },
    };

    checkedDateKeys.forEach(date => {
      let
        wl = dataByDate[date].WL_M,
        q = dataByDate[date].Q_M,
        stage = stageAddition(wl, h0 * -1),
        genQ = (() => {
          switch (type) {
            case 1: return a * (stage ** b);                        // Power Series
            case 2: return a + (b * stage) + (c * stage * stage);   // Polynomial Series
            default: return null;
          }
        })(),
        timestamp = getDisplayDate(date, { returnMills: true });

      observedDischarge.push([stage, q]);

      timeSeries.wl.push([timestamp, wl]);
      timeSeries.stage.normal.push([timestamp, stage]);
      timeSeries.stage.log.push([timestamp, Math.log(stage)]);
      timeSeries.q.normal.push([timestamp, q]);
      timeSeries.gen_q.normal.push([timestamp, genQ]);
      timeSeries.q.log.push([timestamp, Math.log(q)]);
      timeSeries.gen_q.log.push([timestamp, Math.log(genQ)]);
    });
    observedDischarge.sort((a, b) => a[1] - b[1]);
    let ratingEquation = getRatingCurve(observedDischarge, toJS(this.item));
    return {
      timeSeries,
      observedDischarge: {
        normalSeries: observedDischarge,
        logSeries: observedDischarge.map(item => ([Math.log(item[0]), Math.log(item[1])]))
      },
      ratingEquation
    };
  }
  
  onSave = e => {
    e.preventDefault();
    const { ratingEquationStore, params } = this.props;
    const { notify } = this.context;

    let payload = {
      type: this.item.type,
      offset: this.item.offset === '' ? null : this.item.offset,
      a: this.item.a === '' ? null : this.item.a,
      b: this.item.b === '' ? null : this.item.b,
      c: this.item.c === '' ? null : this.item.c,
      stage_from: this.stageRange.from,
      stage_to: this.stageRange.to,
      rating_curve_id: params.id
    }
    const save = () => (this.editMode ? ratingEquationStore.updateEquation(Object.assign(payload, { id: this.item.id })) : ratingEquationStore.createEquation(payload));

    save().then(() => {
      notify.success({ message: 'Success' });
    }).catch(err => {
      notify.error(err);
    });

  }

  @action changeDataByDate = (min, max) => {
    Object.keys(this.dataByDate).forEach(date => {
      this.dataByDate[date].checked = this.dataByDate[date].checked && (this.dataByDate[date].Q_M >= min && this.dataByDate[date].Q_M <= max)
    })
  }

  render() {
    const { stationStore, ratingEquationStore, rolePermissionStore, params } = this.props;

    const curve = ratingEquationStore.findById(params.id)
    if (!curve) return <div />

    const ratingCurveData = this.getRatingCurveData(this.dataByDate);
    const curveStation = stationStore.findById(curve.station_id);
    const canModifyHydrology = rolePermissionStore.validateRole('modify hydrology');

    return <div className="full-width">
      <div className='flex flex-row space-between'>
        <h1 style={{ color: '#4c4c4c' }}>
          <Link to='/hydrology/rt_equations/list'><i className='fa fa-arrow-left' style={{ fontSize: '25px', marginRight: '20px' }} /></Link>
          {!!curve && curve.name}
        </h1>
      </div>
      <Form>
        <FormBody>
          <div className="inline-grid space-between overflow-x-hidden">
            <div>
              {/* <TextInput label='Station' value={!!curveStation ? curveStation.name : ''} readOnly /> */}
              <div className='formInput'>
                <label>Station</label>
                <a href={`#/station/${curveStation.id}/monitoring`} target='_blank' className={'button button-inactive'} style={{ maxWidth: '230px', margin: 0, fontSize: '14px' }}>{!!curveStation ? curveStation.name : ''}</a>
              </div>
              <TextInput label='Date From' value={curve.start_time} readOnly />
              <TextInput label='Date To' value={curve.end_time} readOnly />
            </div>
            <div>
              <div className="flex" style={{ alignItems: 'center' }}>
                <TextInput type='number' label='Offset (h0)' value={this.item.offset} onChange={e => this.onChangeField(e, 'offset')} inputProps={{ step: 0.01, className: this.item.offset == this.optimum.offset ? 'input-highlight' : '' }} readOnly={+this.item.type !== 1} />
                <input type='checkbox' value={this.offsetChecked} onChange={(e) => {
                  this.offsetChecked = !this.offsetChecked
                }} />
              </div>
              <TextInput type='number' label='a' value={this.item.a} onChange={e => this.onChangeField(e, 'a')} inputProps={{ step: 0.01, className: this.item.a == this.optimum.a ? 'input-highlight' : '' }} />
              <TextInput type='number' label='b' value={this.item.b} onChange={e => this.onChangeField(e, 'b')} inputProps={{ step: 0.01, className: this.item.b == this.optimum.b ? 'input-highlight' : '' }} />
              <TextInput type='number' label='c' value={this.item.c} onChange={e => this.onChangeField(e, 'c')} inputProps={{ step: 0.01, className: this.item.c == this.optimum.c ? 'input-highlight' : '' }} readOnly={+this.item.type !== 2} />
            </div>
            <div>
              <SelectInput label={'Series Type'} value={this.item.type} fields={{ label: 'label', value: 'value' }} options={ratingEquationStore.seriesTypeOptions} onChange={e => this.onChangeField(e, 'type')} />
              <RangeInput label={'Stage Range'} value={this.stageRange} onChange={this.onChangeStageRange} min={0} />
              <TextInput label='RMSE' value={_.get(ratingCurveData, 'ratingEquation.rmse', '-')} readOnly />
              <TextInput label='R²' value={_.get(ratingCurveData, 'ratingEquation.r2', '-')} readOnly />
            </div>
          </div>
          {this.editMode && <div onClick={() => this.auditView = true} style={{ float: 'right', fontStyle: 'italic', color: '#006effab', textDecoration: 'underline', fontSize: '14px', cursor: 'pointer' }}>View audit history</div>}
        </FormBody>
        <FormActions >
          <button onClick={this.showObservations}>View</button>
          <button onClick={e => { e.preventDefault(); this.optimizeOffset({ updateParameters: true }); }}>Optimise</button>
          {canModifyHydrology && <button onClick={this.onSave}>Save</button>}
        </FormActions >
      </Form>
      {this.loading && <Spinner />}
      {!!Object.keys(this.dataByDate).length && <div className='rating-curve-table'>
        <div>
          {!!ratingCurveData &&
            <RTGraph ratingCurveData={ratingCurveData} graphSettings={this.graphSettings} series_type={this.item.type}
              onMouseOver={(x, y) => { this.selectedPoint.x = x; this.selectedPoint.y = y; }}
              onGraphSelect={(event) => {
                let xAxis = event.xAxis;
                if (xAxis) {
                  let min = Math.floor(xAxis[0].min), max = Math.floor(xAxis[0].max);
                  this.changeDataByDate(min, max);
                }
              }}
            />}
          <div className="inline-grid">
            <SwitchInput label={'Time Series View'} value={this.graphSettings.useTimeSeries} onChange={() => this.graphSettings.useTimeSeries = !this.graphSettings.useTimeSeries} />
            <SwitchInput label={'Logarithm Scale'} value={this.graphSettings.useLog} onChange={() => this.graphSettings.useLog = !this.graphSettings.useLog} />
            {!this.graphSettings.useTimeSeries && <SwitchInput label={'Toggle Axis'} value={this.graphSettings.toggleAxis} onChange={() => this.graphSettings.toggleAxis = !this.graphSettings.toggleAxis} />}
          </div>
        </div>
        <div>
          <RTable dataByDate={this.dataByDate} parameters={this.item} parameterOffsets={this.item} useLog={this.graphSettings.useLog} selectedPoint={this.selectedPoint} optimizeOffset={this.optimizeOffset} />
        </div>
      </div>}
      {this.editMode && this.auditView && <REAuditHistory params={params} onClose={() => this.auditView = false} />}
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/Hydrology/RTEquations/RatingCurveEquationModify.js